import "./GoogleMap.scss"

const GoogleMap = () => {

    return(
    <section className="google-map">
        <div className="container">
   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d185895.2691874623!2d5.2158275242174135!3d43.2804706594669!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c9bf4344da5333%3A0x40819a5fd970220!2z0JzQsNGA0YHQtdC70Yw!5e0!3m2!1sru!2sfr!4v1740166323853!5m2!1sru!2sfr" width="600" height="450" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </section>
    )
}

export default GoogleMap